import { politicConfigs } from './politic.configs';
import { getSystemPolitics } from '../../core/solar-system/system-politics';
import { pipe } from 'rxjs';
import memoize from 'fast-memoize';

export const getPoliticConfig = memoize(
  pipe(getSystemPolitics, (politics) => politicConfigs[politics]),
);
